import { calcService } from '@src/income/domain/services';
const createIncomeDetail = (income, lastIncomeSaved) => {
    const annualYield = income.applicationYield;
    const incomeSaved = calcService.getCurrentlyIncomeSaved(income);
    const annualContribution = calcService.getAnnualContribution({
        saved: incomeSaved,
    })(lastIncomeSaved);
    const finalValue = calcService.getFinalValue({
        annualYield,
        annualContribution,
    });
    const annualPassive = calcService.getAnnualPassiveIncome(income)({
        finalValue,
    });
    const monthlyPassive = calcService.getMonthlyPassiveIncome(income)({
        finalValue,
    });
    return {
        annualContribution,
        annualYield,
        finalValue,
        annualPassive,
        monthlyPassive,
    };
};
const isLessThanOrEqualZero = (value) => value <= 0;
const isAnyZeroValue = (data) => Object.values(data).some(isLessThanOrEqualZero);
export const createIncomeDetails = (income) => {
    let currentFinalValue = 0;
    let currentMonthlyPassiveIncome = 0;
    const incomeDetails = [];
    if (isAnyZeroValue(income))
        return incomeDetails;
    while (currentMonthlyPassiveIncome < income.desired) {
        const incomeDetail = createIncomeDetail(income, currentFinalValue);
        currentFinalValue = incomeDetail.finalValue;
        currentMonthlyPassiveIncome = incomeDetail.monthlyPassive;
        incomeDetails.push(incomeDetail);
    }
    return incomeDetails;
};
